<template lang="pug">
.settings
  v-container
    social-settings
    theme-settings(:tenantId="tenantId")
    categories-settings
    
</template>
<script>
import ThemeSettings from "@/components/config/ThemeSettings";
import CategoriesSettings from "@/components/config/CategoriesSettings";
import { mapGetters } from "vuex";
import SocialSettings from "@/components/config/SocialSettings";

export default {
  components: {
    ThemeSettings,
    CategoriesSettings,
    SocialSettings,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {},
  computed: {
    ...mapGetters({
      tenantId: "auth/tenantId",
    }),
  },
};
</script>

<style lang="sass" scoped>
.videoPlayer
  width: 100% !important
  margin-bottom: -5px
</style>
